require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/object/entries.js
// module id = 418
// module chunks = 0